import React from "react";
import * as PropTypes from "prop-types";
import IconButton from "@material-ui/core/IconButton";
import DownloadIcon from "./DownloadIcon";

const DownloadMenuButton = props => (
  <div>
    <IconButton
      aria-label="download"
      disableFocusRipple={true}
      edge="end"
      onClick={props.onClick}
    >
      <DownloadIcon />
    </IconButton>
  </div>
);

DownloadMenuButton.propTypes = {
  onClick: PropTypes.func
};

export default DownloadMenuButton;
